// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"02a6a373","488":"0ff5e4f7","977":"70f47b4f"}[chunkId] + ".chunk.js";
};